<template>
    <section class="detail-bg">
      <div v-if="news" class="detail-content">
        <div class="detail-date">{{ formatISODateToCustom(news.updated_at) }}</div>
        <h2 class="detail-title"><NewsTitle :title="news.title" /></h2>
        <img
          :src="getFullImageURL(news.news_image)"
          :alt="news.title"
          class="detail-image"
          @error="onImageError"
        />
        <div class="detail-description" v-html="news.description" v-linkified></div>
        <div>
        <button class="detail-back-button" @click="goToAllnewss">回最新消息</button>
      </div>
      </div>
      <div v-else class="no-detail">
        <p>沒有選擇的最新消息。</p>
      </div>
    </section>
  </template>
  
  <script>
  import { onImageError, getFullImageURL, formatISODateToCustom } from "@/util/util";
  import { globalParams } from "@/global";
  import NewsTitle from "@/components/home/NewsTitle.vue";

  export default {
    name: "newsDetail",
    components: {
      NewsTitle,
    },
    data() {
      return {
        news: null,
      };
    },
    methods: {
      formatISODateToCustom,
      onImageError,
      getFullImageURL,
      goToAllnewss() {
        this.$router.push("/all-news");
      },
    },
    mounted() {
      this.news = globalParams.shownNews;
  
      if (!this.news) {
        this.$router.push("/all-news");
      }
    },
  };
  </script>
  
  <style scoped>
  </style>
  